import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["original", "toggle", "body"]

  toggle() {
    const hidden = this.originalTarget.classList.toggle("hidden")
    this.toggleTarget.textContent = hidden ? "Show original" : "Hide original"
  }

  async translate(event) {
    event.preventDefault()
    const form = event.currentTarget.closest("form")
    if (!form) return

    this.#showSkeleton()
    const startTime = Date.now()

    const response = await fetch(form.action, {
      method: "POST",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      }
    })
    const html = await response.text()
    const remaining = 1000 - (Date.now() - startTime)
    if (remaining > 0) await new Promise(r => setTimeout(r, remaining))
    Turbo.renderStreamMessage(html)
  }

  #showSkeleton() {
    if (!this.hasBodyTarget) return
    const sk = document.createElement("div")
    sk.className = "space-y-1.5 py-0.5"
    sk.innerHTML =
      '<div class="animate-pulse h-3.5 rounded bg-well w-full"></div>' +
      '<div class="animate-pulse h-3.5 rounded bg-well w-11/12"></div>' +
      '<div class="animate-pulse h-3.5 rounded bg-well w-2/3"></div>'
    this.bodyTarget.replaceWith(sk)
  }
}
